import React, { useEffect, useState } from "react";
import Card from "../../UI/Card/Card";

import ChartLegend from "./ChartLegend";
import SapCalcCountChart from "./SapCalcCountChart";
import AverageSapChart from "./AverageSapChart";
import Preloader from "../../UI/Preloader/Preloader";

import InitiativeButtons from "./InitiativeButtons";

import { useRestClientContext } from "../../../contexts/RestClientContext";
import { useTeamContext } from "../../../contexts/TeamContext";

import "./SapJourney.scss";
import { Serie } from "@nivo/line";
import { Message } from "semantic-ui-react";

export interface SapJourneyDatum {
	record_date: string;
	dream_average_sap: number;
	sap_calc_count: number;
}

interface SapJourneyResponse {
	date_start: string;
	date_end: string;
	data: SapJourneyDatum[];
}

export type SapCountDatum = Omit<SapJourneyDatum, "dream_average_sap">;

const sharedMargin = { top: 50, right: 70, bottom: 50, left: 70 };

const SapJourney = () => {
	const team = useTeamContext();
	const client = useRestClientContext();
	const [loading, setLoading] = useState(true);
	const [avgSapData, setAvgSapData] = useState<Serie[]>([]);
	const [sapCountData, setSapCountData] = useState<SapCountDatum[]>([]);
	const [error, setError] = useState<string>("");

	useEffect(() => {
		setLoading(true);
		setError("");

		client
			.fetchSapJourney(team.id)
			.then((response: Response) => response.json())
			.then((json: SapJourneyResponse) => {
				setLoading(false);
				setAvgSapData([
					{
						id: "avg_sap",
						data: json.data.map((entry) => ({ x: entry.record_date, y: entry.dream_average_sap })),
					},
				]);

				setSapCountData(
					json.data.map((entry) => ({
						record_date: entry.record_date,
						sap_calc_count: entry.sap_calc_count,
					}))
				);
			})
			.catch((_) => {
				setLoading(false);
				setError("Error fetching team SAP data");
			});
	}, [client, team.id]);

	return (
		<Card title="Property Activity Tracker" className="sap-journey">
			{loading ? (
				<Preloader />
			) : error ? (
				<Message error>{error}</Message>
			) : (
				<>
					<ChartLegend />
					<div className="chart-container">
						<SapCalcCountChart data={sapCountData} margin={sharedMargin} />
						<AverageSapChart data={avgSapData} margin={sharedMargin} />
					</div>
					<InitiativeButtons />
					{/*<div className="chart-container">*/}
					{/*	<SapCalcCountChart {...commonChartProps} data={sapCountData} />*/}
					{/*</div>*/}
				</>
			)}
		</Card>
	);
};

export default SapJourney;
